import { render, staticRenderFns } from "./MemberUser.vue?vue&type=template&id=24774248&scoped=true"
import script from "./MemberUser.vue?vue&type=script&lang=js"
export * from "./MemberUser.vue?vue&type=script&lang=js"
import style0 from "./MemberUser.vue?vue&type=style&index=0&id=24774248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24774248",
  null
  
)

export default component.exports